/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {useEffect, useState} from "react";
import {getHubName} from "./helpers";

const useGetHubName = (suffix: string) => {
  const [hubName, setHubName] = useState<string>("");
  useEffect(() => {
    const _hubName = getHubName(suffix)
    setHubName(_hubName);
  }, [suffix]);
  return hubName;
}

export default useGetHubName;